import { AxiosRequestConfig } from "axios";
import React from "react";
import { isEmptyObject } from "./MainPage/Tools/Tools";
import { renderMessageBox, SetLoadingCursor } from "./TokenProcessing/TokenProcessing";
import { getUrlSearh } from "./MainPage/Tools/urlParams.js";
import { appConfig, ipAtom, isAuthorized, pingMinsAtom, smetaStore } from "../atoms";
import smetaAxios from "./SmetaAxios";
import { baseUrl } from "./BaseUrl";

var enter = false,
  intervalId: any,
  returnNotification: any = undefined;

export enum LkTypes {
  yanao = "yanao",
  hmao = "hmao",
  hmaoTest = "hmaoTest",
  umi = "umi",
  vologda = "vologo",
}

export interface ConfigSmeta {
  basename?: string;
  newDesign?: boolean;
  espk?: boolean /*Определение особых функций для еспк*/;
  /*открытие "Вызов" справки в новой вкладке браузера */
  openHelpContextInNewTab?: boolean;
  homeOptions?: {
    header?: {
      height?: number;
    };
  };
  /*разрешение на 1 вкладка = 1 сессия*/
  multiSession?: boolean;
  /*ссылки на плагин для подписания*/
  pluginLinks: {
    chrome: {
      store: string;
      local: string;
    };
    firefox: {
      local: string;
    };
    workspace: {
      [key: string]: string;
      windows: string;
      linux: string;
    };
    howToLink: string;
  };
  /*скрыть имя адреса перенапрваления в Настройки->О сайте*/
  hideServerRedirection?: boolean;
  /*скрыть вход в смету*/
  hideEnter?: boolean;
  /**отключение пингов */
  ping?: boolean;
  stimateVersion: string;
  versionCheckInterval?: number;
  signOptions?: {
    signButtons?: {
      /** Показывать кнопку входа по ЭП */
      signCryptoButton?: boolean;
      /** Показывать кнопку входа в лк */
      lkButton?: boolean;
      /* Показывать кнопку открытия сайта help.krista.ru */
      helpKristaButton?: boolean;
    };
    headerSettings?: {
      /**картинка для страницы входа */
      image?: boolean;
      /**ширина картинки на странице входа */
      imageWidth?: string;
      /**заголовок на странице входа */
      title?: string;
    };
    snowEffect?: boolean;
    splitSignIn?: boolean;
    textAboutButtons?: {
      smeta?: string;
      lk?: string;
    };
  };
}

export interface ConfigLk {
  /*тип лк. для персонализации функций*/
  lkType?: LkTypes;
  /**отображать ли QR код(для скачивание мобильной версии) на странице входа */
  showMobileQR?: boolean | string;
  /**скрытие кнопки входа через есиа */
  hideEsiaButton?: string;
  /**1 - вкл, 0 - выкл // Восстановление пароля */
  basePassRecovery?: string;
  /**1 - вкл, 0 - выкл // Капча */
  baseCaptcha?: string;
  /**1 - ФИО, 0 - СНИЛС, undefined - не отображать снилс //Какое поле отображать в регистрации */
  baseSnilsOrFio?: string;
  /**1 - Лк для УМИ, 0 - Обычный ЛК //Отличается регистрация */
  baseUmi?: string;
  /**ширина картинки 45 стандартное */
  baseWidthLogo?: string;
  /** true - текстовое поле для инн, false|undefined(по умолчанию) - выбор организации из списка */
  textInnField?: boolean;
  /**Текст ссылки при входе(ссылка переход на регистрацию) */
  baseLinkText?: string;
  /*Текст на входе в ЛК */
  titleText?: string;
  /**если true то скрыть всё кроме лого и кнопки входа в ЕСИА */
  hideLoginAndPassword?: boolean;
  /**ссылка на файл/сайт в котором текст для обработки перс данных */
  agreeToProcessPersonalDataLink?: string;
  linkOnSignInPage?: {
    /**ссылка куда переходить при клике */
    link: string;
    /**Текст ссылки куда переходить */
    linkText: string;
  };
  doEsia?: {
    /**адрес для запуска процедуры выхода из учетки есиа */
    logout?: boolean;
    /**вход через гос услуги, если что то задано, то кнопка отобразиться, и при клике на нее будет перенаправление */
    auth?: boolean;
    org?: string;
  };
  /*Вкл особое уведомления ЯНАО на всю страницу */
  checkNotifyme?: string | boolean;
  /*Текст особого уведомления ЯНАО */
  textContentNotifyme?: string;
  url?: {
    /**url для входа */
    signIn?: string;
    /**url для входа регистрации */
    signUP?: string;
    /**Смена пароля принимает новый пароль */
    changePassword?: string;
    /**Запрос на отправку письма на почту, с ссылкой на регистрацию нового пароля */
    restorePassword?: string;
    /*запрос на получения каптчи */
    captcha?: string;
    /*запрос на получения списка организаций */
    org?: string;
    /*запрос на получения списка сотрудников организации */
    fio?: string;
  };
}

declare global {
  interface Window {
    webkcrypt: any;
  }
}

export function removeParam(key: any, sourceURL: string) {
  var splitUrl = sourceURL.split("?"),
    rtn = splitUrl[0],
    param,
    params_arr = [],
    queryString = sourceURL.indexOf("?") !== -1 ? splitUrl[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}

export function getLastLogin() {
  const sessionLastLogin = sessionStorage.getItem("LastLogin"); //SessionStorage
  const localLastLogin = getCookie("LastLogin");
  !sessionLastLogin && !localLastLogin && console.warn("Ошибка парсинга LastLogin");
  return sessionLastLogin || localLastLogin || "";
}

export function getURLparam(key: string) {
  const search: string = getUrlSearh();
  const urlParams = new URLSearchParams(search);
  const param = urlParams.get(key);
  return param || "";
}

export function hasURLparam(key: string) {
  const search: string = getUrlSearh();
  const urlParams = new URLSearchParams(search);
  return urlParams.has(key);
}

type ModalLocation = {
  currentLocation?: {
    height: string;
    left: string;
    top: string;
    width: string;
    windowHeight: number;
    windowWidth: number;
  };
  posBeforeMax: {
    left: number;
    top: number;
  };
  size: {
    height: string;
    width: string;
  };
};

interface Configurator {
  Selected: {
    docid: string;
    DocCfgID: string;
  };
  ID: string;
  CLSID: string;
  from?: "lk";
  Name: string;
  IP: string;
  PingMins: number;
  modalsLocation?: Record<string, ModalLocation>;
  isOrgEnter?: boolean;
  isSuperUser?: boolean;
  isAdmin?: boolean;
  helpContext?: string;
  configEnabled?: boolean;
}

type RootObject = Record<
  string, // drx
  | Record<
      string, // user
      | Record<
          string, // workplace
          Configurator | undefined
        >
      | undefined
    >
  | undefined
>;

export function deleteURLparam(key: string) {
  const search: string = getUrlSearh();
  const urlParams = new URLSearchParams(search);
  urlParams.delete(key);
}

export function updateOptionsForUser(data: any) {
  const [drx, user, workplace] = getLastLogin().split(",");
  const currentSecJSON: string = getCookie("CurrentSecJSON");
  const parsedJson: RootObject = currentSecJSON === "" ? {} : JSON.parse(currentSecJSON);
  const jsoncrrsec: RootObject = {
    ...parsedJson,
    [drx]: {
      ...parsedJson?.[drx],
      [user]: {
        ...parsedJson?.[drx]?.[user],
        [workplace]: {
          ...parsedJson?.[drx]?.[user]?.[workplace],
          ...data,
        },
      },
    },
  };

  createCokies("CurrentSecJSON", JSON.stringify(jsoncrrsec));
}

export function getOptionsForUser() {
  let jsoncrrsec: RootObject = getCookie("CurrentSecJSON");
  const [drx, user, workplace] = getLastLogin().split(",");
  jsoncrrsec = jsoncrrsec === "" ? {} : JSON.parse(jsoncrrsec);
  return jsoncrrsec?.[drx]?.[user]?.[workplace];
}

export function createCokies(name: string, value: any) {
  document.cookie = name + "=" + value;
  localStorage.setItem(name, value);
}
export function getCookie(cookieName: string) {
  const results = localStorage.getItem(cookieName);
  if (results) return results;
  else return "";
}
function getRandomArbitrary(min: number, max: number) {
  const res = Math.floor(Math.random() * (max - min) + min);
  return res;
}

export const createPingInterval = () => {
  const isAuth = smetaStore.get(isAuthorized);
  if (!isAuth) return null;
  const pingTimeInterval = smetaStore.get(pingMinsAtom);
  return setInterval(() => {
    pingServer();
  }, pingTimeInterval);
};

export const pingServer = (setNotifications?: any) => {
  //todo отрефакторить на атомы и связи с header
  if (smetaStore.get(appConfig).smeta.ping !== false) {
    if (returnNotification === undefined && setNotifications !== undefined) {
      returnNotification = setNotifications;
    }
    const loadMasks: any = document.querySelectorAll("[loadmask]");

    if (loadMasks.length > 0) {
      for (const val of loadMasks) {
        val.parentElement.remove();
      }
    }

    const axiosConfig: AxiosRequestConfig = {
      loadMask: true,
      params: {
        smart: "1",
      },
    };
    return smetaAxios.get("ping", axiosConfig).then((json) => {
      if (!isEmptyObject(json) && returnNotification) returnNotification(json);
      return json;
    });
  }
};

export function checkGenLicGuid(LicGuid: any, createNew?: boolean) {
  //Проверка|Генерация LicGuid
  let LicGUID = LicGuid;
  if (LicGUID === "" || LicGUID === null || createNew) {
    var s = "0123456789ABCDEFGHIKLMNOPQRSTVXYZ";
    for (var n = 0; n <= 31; n++) {
      if (n === 0) {
        LicGUID = s[getRandomArbitrary(1, 31)];
      } else {
        LicGUID = LicGUID + s[getRandomArbitrary(1, 31)];
      }
    }
    sessionStorage.setItem("LicG", LicGUID);
  }
  return LicGUID;
}

export function getUrlForRequest(params: any, LicGUID?: string) {
  //Создание ссылки запроса
  let attachment: any = new Map(params);
  attachment.delete("prefix");
  attachment.delete("comand");
  const guid = LicGUID || sessionStorage.getItem("LicG");
  let result = "";

  const keys = Array.from(attachment.keys()); //разбор карты вложений на ключи
  for (let key of keys) {
    if (attachment.get(key) !== undefined) {
      result += `&${key}=${`${attachment.get(key)}`.replaceAll("/", "%2f")}`;
    }
  }
  return `${baseUrl}${params.get("prefix") === undefined ? "project" : params.get("prefix")}/${params.get(
    "comand",
  )}?LicGUID=${guid}${result}`;
}

export function XMLrequest(params: any, postData?: any) {
  var LicGUID: any,
    request = new XMLHttpRequest(),
    res = "",
    method;

  if (params.has("LicGUID")) {
    LicGUID = params.get("LicGUID");
    params.delete("LicGUID");
  } else {
    LicGUID = sessionStorage.getItem("LicG");
    LicGUID = checkGenLicGuid(LicGUID);
  }

  const url = getUrlForRequest(params, LicGUID);
  postData === undefined ? (method = "GET") : (method = "POST");
  request.open(method, url, false);
  // request.setRequestHeader("Access-Control-Allow-Origin", "*")
  // request.setRequestHeader("Access-Control-Allow-Methods", "GET,PUT,POST,DELETE,PATCH,OPTIONS")
  request.onload = function () {
    res = request.responseText;
  };
  if (postData) {
    let json = JSON.stringify(postData);
    request.send(json);
  } else request.send();

  try {
    let parsedJSON = JSON.parse(res);
    if (parsedJSON.error && params.get("comand") !== "enter") {
      const Message = `Ошибка выполнения операции на сервере: ${parsedJSON.error.content}`;
      renderMessageBox({ dlgType: 1, buttons: 1, message: Message });
    }
    parsedJSON = checkServerAnswer(parsedJSON);
    return parsedJSON;
  } catch (err) {
    console.log(err);
  }
}
export default function URL(params: any, postData?: any) {
  var LicGUID: any;
  LicGUID = sessionStorage.getItem("LicG");
  LicGUID = checkGenLicGuid(LicGUID);
  return getUrlForRequest(params, LicGUID);
}

function CheckIsEmptyAnswer(json: any) {
  if (isEmptyObject(json) || json === undefined || json === null) {
    createCokies("LicG", "");
    if (getOptionsForUser()?.from && smetaStore.get(appConfig).smeta.hideEnter === true) {
      window.location.href = getOptionsForUser()?.from.replaceAll("@", "/");
    } else {
      window.location.href = window.location.hostname + window.location.pathname;
    }
  }
}

export function checkServerAnswer(json: any) {
  if (json.Message?.content) {
    renderMessageBox({ dlgType: 2, buttons: 1, message: json.Message.content });
    delete json.Message;
  }
  if (json.error && json.error.NeedNewPW === undefined && json.error.LicRes === undefined) {
    renderMessageBox({ dlgType: 1, buttons: 1, message: json.error.content });
    delete json.error;
  }
  return json;
}

export async function AxiosRequest(loadMask: boolean, params: any, postData?: object | AxiosRequestConfig) {
  let LicGUID: any, res, mask: HTMLDivElement | undefined;
  // let res = Object;
  LicGUID = sessionStorage.getItem("LicG");
  if (params.has("LicGUID")) {
    LicGUID = params.get("LicGUID");
  } else {
    LicGUID = checkGenLicGuid(LicGUID);
  }
  const paramsJson = Object.fromEntries(params);
  const { prefix, comand } = paramsJson;

  // if (loadMask) mask = setLoadingCursorAxios(loadMask);
  delete paramsJson.comand;
  delete paramsJson.prefix;
  const config = { prefix: prefix || "project", loadMask: loadMask, params: { LicGUID, ...paramsJson } };
  try {
    if (!postData) {
      return smetaAxios.get(comand, config).then((response) => {
        res = response;
        return res;
      });
    } else {
      return smetaAxios.post(comand, postData, config).then((response) => {
        res = response;
        return res;
      });
    }
  } catch {}
  //(res)
  return res;
}

function removeLoadingCursor(loadMask: any) {
  SetLoadingCursor(loadMask, undefined, true);
}

export function ImgURL(attachment?: any, style?: React.CSSProperties, path?: string) {
  let origin = `${baseUrl.replace("/web~", "")}/web~${attachment}`;
  const ip = smetaStore.get(ipAtom);
  if (ip) {
    origin += "?ip=" + ip;
  }
  return <img key={path} alt="" style={style} src={origin} />;
}

export function ImgURLSRC(attachment?: any) {
  if (attachment) {
    let origin = `${baseUrl.replace("/web~", "")}/web~${attachment}`;
    const ip = smetaStore.get(ipAtom);
    if (ip) {
      origin += "?ip=" + ip;
    }
    return origin;
  }
}

export function ImgBASE64(attachment?: any, path?: string) {
  return <img key={path} alt="" src={`data:image/png;base64,${attachment}`} />;
}
